import { useEffect } from 'react';

const RedirectOnboarding = () => {
  useEffect(() => {
    window.location.href = 'https://youtube.com/shorts/SMJBlvGXjTA?feature=share';
  }, []);

  return null;
};

export default RedirectOnboarding